import React, { useEffect, useState } from 'react';
import { useCountdown } from '../hooks/useCountdown';

const DateTimeDisplay = ({ value, type, isDanger }) => {
  return (
    <div>
      <p className='text-[32px] font-bold text-white leading-[58px] mb-1 w-[75px]'>{value}</p>
      <span className='md:text-[20px] opacity-40'>{type}</span>
    </div>
  );
};

function Countdown({ date, simple = false, onEnd }) {
  const [days, hours, minutes, seconds] = useCountdown(date);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    setRendered(true);
  }, []);

  useEffect(() => {
    if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
      if (onEnd) {
        onEnd();
      }
    }
  }, [days, hours, minutes, seconds]);

  if (!rendered) return <></>;

  if (simple) {
    if (days > 0) {
      return (
        <>
          {days} days {hours} hrs {minutes} mins {seconds} s
        </>
      );
    } else if (hours > 0) {
      return (
        <>
          {hours} hrs {minutes} mins {seconds} s
        </>
      );
    } else if (minutes > 0) {
      return (
        <>
          {minutes} mins {seconds} s
        </>
      );
    } else if (seconds > 0) {
      return <>{seconds} s</>;
    }

    return '';
  }

  return (
    <div className='flex flex-col items-center justify-center text-center'>
      <div className='flex space-x-5'>
        <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} />
        <DateTimeDisplay value={hours} type={'Hours'} />
        <DateTimeDisplay value={minutes} type={'Mins'} />
        <DateTimeDisplay value={seconds} type={'Seconds'} />
      </div>
    </div>
  );
}
export default Countdown;
